import CopyButton from './CopyButton';

export default function CodeBlock({ code, copy = true }) {
  return (
    <div style={{ position: 'relative' }}>
      <pre
        style={{
          background: 'var(--bg-1)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--r-md)',
          padding: 'var(--sp-4)',
          overflowX: 'auto',
          fontSize: 12.5,
          lineHeight: 1.7,
          color: 'var(--text-2)',
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
          margin: 0,
        }}
      >
        <code>{code}</code>
      </pre>
      {copy && (
        <div style={{ position: 'absolute', top: 8, right: 8 }}>
          <CopyButton text={code} />
        </div>
      )}
    </div>
  );
}
